export class AppEnums {
}

export enum ResponseTypes {
	RadioButtonVertical = "1",
	RadioButtonHorizontalWithHeader = "2",
	RadioButtonHorizontalWithoutHeader = "3",
	Textbox = "4",
	DropDownList = "5",
	QuestionWithNoAnswers = "6",
	SkipLogicQuestion = "7",
	TermsAndConditions = "8"
}

export enum LaunchStatus {
	LaunchClosed = "complete",
	LaunchOngoing = "live",
	LaunchBeingBuilt = "setup",
	LaunchBeingTransferred = "launching"
}

export enum ResponseStatus {
	responseNotStarted = "NOT_STARTED",
	responseSubmitted = "SUBMITTED",
	responseInProgress = "IN_PROGRESS"
}

export enum ResponseText {
	maxCharacterCount = 1500,
	maxOtherAnswerCount = 80
}